<template>
  <v-row justify="space-around">
    <v-col
      :cols="$vuetify.breakpoint.mdAndUp ? 10 : 12"
      xs="12"
      sm="12"
      md="12"
      lg="12"
      xl="12"
    >
      <v-card outlined class="dialog-cls pa-4">
        <v-card-title class="justify-center general-title text-uppercase">{{
          productsData.name + " / " + productsData.strainCultivar
        }}</v-card-title>
        <v-row justify="center">
          <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
            <graph-pie
              :height="500"
              :values="values"
              :names="names"
              :active-event="'click'"
              :show-text-type="'outside'"
              :data-format="dataFormat"
              :shape="'donut'"
              :colors="colorsList"
            >
              <tooltip :names="names"></tooltip>
            </graph-pie>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";
import VueGraph from "vue-graph";
import { TERPENE_CHART_COLORS } from "@/constants";
Vue.use(VueGraph);
export default {
  name: "ProductChart",
  props: {
    productsData: Object
  },
  data() {
    return {
      values: [],
      names: [],
      colorsList: TERPENE_CHART_COLORS
    };
  },
  mounted() {
    if (
      this.productsData.parameters &&
      this.productsData.parameters.length > 0
    ) {
      this.productsData.parameters.forEach(parameter => {
        const res = parseFloat(parameter.result);
        const resultVal = !isNaN(res) ? res : 0;
        if (resultVal !== 0) {
          this.values.push(resultVal);
          this.names.push(parameter.name);
        }
      });
    }
  },
  methods: {
    dataFormat: function(name, value) {
      const sumValues = this.values.reduce((a, b) => a + b, 0);
      const perVal = (value * 100) / sumValues;

      if (value) return this.names[name] + " (" + perVal.toFixed(2) + "%)";
    }
  }
};
</script>
